<template>

    <div>
        <div v-bind:style="{'width': width + 'px'}">

            <div v-show="(image && image.url) || (newImage && newImage.url)" v-bind:class="[(image && image.url && background != null) ? 'd-inline-block rounded p-1' : '', 'image mb-1']" v-bind:style="[(image && image.url && background != null) ? {'background': background} : null, {'width': width + 'px'}, {'aspect-ratio': cropAspectRatio}]">
                <vue-cropper style="width: 100%; height: 100%;" v-show="!disabled && cropAvailable && editMode" ref="cropper" :src="newImage ? newImage.url : null" :view-mode="0" :aspect-ratio="cropAspectRatio" :auto-crop-area="1" :zoom-on-wheel="false"></vue-cropper>
                <img v-show="(!cropAvailable || (cropAvailable && !editMode)) && image && image.url" v-bind:src="image ? image.url : null" ref="preview" class="img-responsive preview" alt="" style="width: 100%; height: 100%;">
            </div>

        </div>

        <div class="mb-1" v-if="image && image.url"></div>

        <!--        <p v-if="image">{{ getNameFromUrl(image) }}</p>-->

        <div>
            <a href="javascript:void(0)" class="btn btn-sm btn-primary" v-if="editMode" @click="zoom(0.1)">
                <i class="fa fa-search-plus"></i>
            </a>
            <a href="javascript:void(0)" class="btn btn-sm btn-primary" v-if="editMode"  @click="zoom(-0.1)">
                <i class="fa fa-search-minus"></i>
            </a>
            <a href="javascript:void(0)" class="btn btn-sm btn-warning" v-if="!disabled && cropAvailable && image && image.url && !editMode" @click="openEditMode">{{ t.__('Kadruj') }}</a>
            <a href="javascript:void(0)" class="btn btn-sm btn-success" v-if="!disabled && cropAvailable && newImage && newImage.url && editMode" @click="approveNewImage">{{ t.__('Zatwierdź') }}</a>
            <a href="javascript:void(0)" class="btn btn-sm btn-warning" v-if="!disabled && cropAvailable && newImage && newImage.url && editMode" @click="closeEditMode">{{ t.__('Anuluj') }}</a>
            <a href="javascript:void(0)" class="btn btn-sm btn-primary" v-if="!disabled && !editMode" @click="showFileManager()">
                <span v-if="image === undefined || image === null || image.url === null || image.url === undefined">{{ t.__('Wybierz grafikę') }}</span>
                <span v-if="image !== undefined && image !== null && image.url !== null && image.url !== undefined">{{ t.__('Zmień grafikę') }}</span>
            </a>
            <a href="javascript:void(0)" class="btn btn-sm btn-danger" v-if="!disabled && image !== undefined && image !== null && image.url !== null && image.url !== undefined && !editMode" @click="clear()">{{ t.__('Usuń') }}</a>
        </div>

        <div class="hint-text" v-if="!hideHints && (hint !== '' || additionalHint !== '')">
            <div v-if="additionalHint !== ''" v-html="additionalHint"></div>
            <div v-if="hint !== ''" v-html="hint"></div>
        </div>

    </div>

</template>

<script>

import Image from "./classes/Image";
import mime from 'mime';

export default {
    props: {
        inputName: {
            type: String,
            default: null
        },
        value: {
            type: Object,
            default: null
        },
        mimeTypes: {
            type: String,
            default: 'image/jpeg,image/png,image/webp'
        },
        cropAvailable: {
            type: Boolean,
            default: false,
        },
        width: {
            type: Number,
            default: 370
        },
        cropAspectRatio: {
            type: Number,
            default: NaN
        },
        background: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        additionalHint: {
            type: String,
            default: ''
        },
        hideHints: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            eventHub: window.eventHub,
            image: this.value,
            newImage: null,
            croppr: null,
            editMode: false,
            initCropData: null,
            lastCropDataFull: null,
            imageChanged: false,
            imgRealUrl: null,
            newImgRealUrl: null,
            hint: ''
        }
    },
    model: {
        event: 'change'
    },
    methods: {
        showFileManager() {
            this.eventHub.$emit('show-file-manager', this._uid, 'file', this.mimeTypes)
        },
        clear() {
            this.image.reset();
            this.$emit('change', this.image);
            this.editMode = false;
        },
        getNameFromUrl(url) {
            return url.substring(url.lastIndexOf('/')+1);
        },
        openEditMode() {
            this.newImage = JSON.parse(JSON.stringify(this.image))
            this.editMode = true;
            this.$refs.cropper.replace(this.imgRealUrl);
        },
        closeEditMode () {
            this.lastCropDataFull = this.$refs.cropper.getData();
            this.newImage = new Image();
            this.editMode = false
        },
        zoom(percent) {
            this.$refs.cropper.relativeZoom(percent);
        },
        approveNewImage() {
            this.imgRealUrl = this.$refs.cropper.getCroppedCanvas().toDataURL();
            this.image = JSON.parse(JSON.stringify(this.newImage))
            this.image = new Image(this.imgRealUrl);
            this.image.new_image_data = this.newImage.new_image_data;
            this.image.crop_changed = this.newImage.crop_changed;
            this.image.crop_data = this.newImage.crop_data;
            this.image.delete_image = this.newImage.delete_image;
            this.image.cropped_image = this.imgRealUrl;
            this.$emit('change', this.image);
            this.imageChanged = true;
            this.closeEditMode();
        }
    },
    beforeMount() {
        if (this.mimeTypes) {
            const allowedExtensions = this.mimeTypes.split(',')
                .map(mimeType => Array.from(mime.getAllExtensions(mimeType)))
                .flat();
            if (allowedExtensions.length) {
                this.hint = t.__('Dozwolone rozszerzenia: ') + allowedExtensions.join(', ') + '.'
            }
        }
    },
    mounted() {

        if (this.image == null) {
            this.image = new Image();
        }

        this.newImage = new Image();

        this.imgRealUrl = this.image.url;

        this.eventHub.$on('file-manager-selected-' + this._uid, (file) => {
            this.newImage = new Image();
            this.newImage.selectFromLibrary(file);
            this.newImgRealUrl = this.newImage.url;
            this.eventHub.$emit('hide-file-manager');
            if (this.cropAvailable) {
                this.$refs.cropper.replace(this.newImgRealUrl);
                this.editMode = true;
            } else {
                this.image = this.newImage
                this.image.url = this.imgRealUrl;
                this.$emit('change', this.image);
                this.imageChanged = true;
            }
        });

        if (this.cropAvailable) {
            // this.$refs.cropper.$el.addEventListener('ready', (event) => {
            //     this.$refs.cropper.setData(this.lastCropDataFull);
            // });
            this.$refs.cropper.$el.addEventListener('crop', (event) => {
                if (this.newImage.url) {
                    let cropData = {
                        x: event.detail.x,
                        y: event.detail.y,
                        width: event.detail.width,
                        height: event.detail.height
                    };
                    let init = this.initCropData === null
                    if (init) {
                        this.initCropData = cropData;
                    }
                    this.newImage.crop_data = cropData;

                    this.newImage.crop_changed = this.newImage.crop_data.x !== this.initCropData.x
                        || this.newImage.crop_data.y !== this.initCropData.y
                        || this.newImage.crop_data.width !== this.initCropData.width
                        || this.newImage.crop_data.height !== this.initCropData.height;
                }
            });
        }

    },
    watch: {
        value: function(newVal, oldVal) {
            this.image = this.value;
            if (this.image && this.image.url) {
                if (this.cropAvailable) {
                    this.$refs.cropper.replace(this.imgRealUrl);
                }
                this.imageChanged = true;
            }
        }
    }
};
</script>

<style scoped>

.image {
    background-color: white;
    background-image: linear-gradient(
            45deg,#ccc 25%,transparent 0),linear-gradient(
            -45deg,#ccc 25%,transparent 0),linear-gradient(
            45deg,transparent 75%,#ccc 0),linear-gradient(
            -45deg,transparent 75%,#ccc 0);
    background-size: 16px 16px;
    background-position: 0 0, 0 8px, 8px -8px, -8px 0;
}

.btn i {
    margin-right: 0;
}

.cropper-container.cropper-bg {
    width: 100% !important;
    height: 100% !important;
}

.crop-preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
}
.crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
}
.cropped-image img {
    max-width: 100%;
}

.btn-sm {
    padding: 0.25rem 0.5rem;
}

.hint-text {
    font-size: 12px;
    color: white;
    margin-top: 5px;
}

</style>
